var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":_vm.url,"title":"二维码","scrolling":_vm.scrolling,"width":(_vm.width + "px"),"height":(_vm.height + "px")}})}
var staticRenderFns = []

export { render, staticRenderFns }